import { useState } from "react";
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { Container, Nav, Navbar, Offcanvas, Alert } from "react-bootstrap";
import { logout } from "../../Auth";
import "../../assets/scss/pages/dashboard/dashboard.scss";

const DashboardLayout = () =>  {
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    // Handles user logout
    const handleLogout = async () => {
        const result = await logout();

        if (result.success) {
            setIsLoggedOut(true);
        } else {
            setErrorMessage(result.message);
        }
    }

    if (isLoggedOut) {
        return <Navigate to="/admin" replace />
    }

    return (
        <Container fluid className="dashboard d-lg-flex flex-grow-1 px-lg-0">
            <Navbar collapseOnSelect
                expand="lg"
                className="d-lg-flex flex-lg-column flex-grow-1 align-items-start px-3 w-25 py-4 py-lg-5"
                id="nav-section"
            >
                <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />
                <Navbar.Offcanvas
                    id="offcanvasNavbar-expand-lg"
                    aria-labelledby="offcanvasNavbarLabel-expand-md"
                    placement="start"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                          Menu
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="d-lg-flex flex-lg-column justify-content-end flex-grow-1 pe-3">
                            {/* Home */}
                            <Nav.Link
                                as={NavLink}
                                to="/dashboard"
                                eventKey="dashboard" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Home
                            </Nav.Link>

                            {/* Manage Listings */}
                            <Nav.Link
                                as={NavLink}
                                to="/dashboard/manage-listings"
                                eventKey="listings" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Manage Listings
                            </Nav.Link>

                            {/* Manage Reviews */}
                            <Nav.Link
                                as={NavLink}
                                to="/dashboard/manage-reviews"
                                eventKey="contact" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Manage Reviews
                            </Nav.Link>

                            {/* Manage Team */}
                            <Nav.Link
                                as={NavLink}
                                to="/dashboard/manage-team"
                                eventKey="team" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Manage Team
                            </Nav.Link>

                            {/* Logout */}
                            <Nav.Link
                                className="text-danger fw-semibold"
                                eventKey="logout"
                                onClick={ handleLogout }
                            >
                                Logout
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Navbar>

            <Container fluid className="p-sm-5 dashboard">
                {/* Display logout error message */}
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}

                <Outlet /> {/* Render child routes */}
            </Container>
        </Container>
    )
}

export default DashboardLayout;
